// extracted by mini-css-extract-plugin
module.exports = {"livechat":"dynamo-livechat_livechat__UAOs9"};